export default __webpack_public_path__ + "static/media/project-wizard-patient-properties.191ed48b.png";